import React, { useEffect, useState } from "react";
import Header from '../../common/Header'
import Sidebar from '../../common/Sidebar'
import Footer from '../../common/Footer'
import PageHeader from '../../pages/PageHeader'
import axios from "axios";
import { triggerAlert, ConfirmationAlert } from '../../utils';
import Loader from '../../common/Loader'
import DataTable from 'react-data-table-component';
import { Modal, ModalBody } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { Menu, MenuItem } from "@mui/material";
import Cookies from 'js-cookie';

export default function Creditconfig() {
    document.title = "Digital Employees - Credit Config"
    const mainHeading = "Creditconfig List";
    const heading = "Settings / Creditconfig List";

    const [isLoading, setIsLoading] = useState(true);
    const [listData, setListData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [textbase, settextbase] = useState("Create");
    const [CreatenewUser, setCreatenewUser] = useState(false);
    const [editid, seteditid] = useState('');
    const [selectedid, setselectedid] = useState('');
    const [selectedidData, setselectedidData] = useState({});
    const [SelectedStatus, setSelectedStatus] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const { register: registerForm, handleSubmit: handleSubmitForm, formState: { errors: errorsForm }, setValue: setValueForm, reset: resetForm, trigger } = useForm();

    const [customerlist, setcustomerlist] = useState(false);
    const [customeradd, setcustomeradd] = useState(false);
    const [customeredit, setcustomeredit] = useState(false);
    const [customerdelete, setcustomerdelete] = useState(false);

    const access_privileges = JSON.parse(Cookies.get('modulepermissions') || '[]');

    useEffect(() => {
        access_privileges.map((access) => {
            access.sub_module_info.map((subaccess) => {
                if (subaccess.name == "Config" && subaccess.permissions.indexOf(1) !== -1) {
                    setcustomerlist(true);
                }
                if (subaccess.name == "Config" && subaccess.permissions.indexOf(2) !== -1) {
                    setcustomeradd(true);
                }
                if (subaccess.name == "Config" && subaccess.permissions.indexOf(3) !== -1) {
                    setcustomeredit(true);
                }
                if (subaccess.name == "Config" && subaccess.permissions.indexOf(4) !== -1) {
                    setcustomerdelete(true);
                }
            });
        });
        fetchListData(1);
    }, []);

    const handleClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setselectedid(row.id);
        setselectedidData(row);
        setSelectedStatus(row.is_active);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (CreatenewUser) {
            handleClose();
        }
    }, [CreatenewUser]);

    const fetchListData = async (page, size = perPage, searchkey = searchQuery) => {
        setIsLoading(true);
        try {
            let token = Cookies.get("admin_user_token");
            const response = await axios.get(
                `/api/admin/add-credit-packs/?limit=${size}&offset=${(page - 1) * size}${searchkey ? `&search=${searchkey}` : ""}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const response_data = response.data;
            if (response.status === 200) {
                const itemsArray = response_data.results;
                itemsArray.map((item, i) => {
                    item.Num = ((page - 1) * size) + i + 1;
                    return item;
                });
                setTotalRows(response_data.count);
                setListData(itemsArray);
                setIsLoading(false);
            } else {
                setListData([]);
                setIsLoading(false);
                setTotalRows(0);
            }
        } catch (error) {
            setListData([]);
            setIsLoading(false);
            setTotalRows(0);
        }
    };

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchListData(1, perPage, searchQuery);
            setCurrentPage(1);
        }, 1000);

        return () => clearTimeout(delayDebounceFn);
    }, [searchQuery]);

    const handleKeySearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const columns = [
        {
            name: <label className="DarkBlue4_Color font_weight_500 font_14">S.No</label>,
            sortable: true,
            selector: row => row.Num,
            cell: row => (
                <div className="DarkBlue4_Color font_weight_300 font_14 align-middle">
                    <span>{row.Num}</span>
                </div>
            ),
            width: "80px"
        },
        {
            name: <label className="DarkBlue4_Color font_weight_500 font_14">Pack Name</label>,
            sortable: true,
            selector: row => row.name,
            cell: row => (
                <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
                    {row.name}
                </div>
            ),
        },
        {
            name: <label className="DarkBlue4_Color font_weight_500 font_14">Credits</label>,
            sortable: true,
            selector: row => row.credits,
            cell: row => (
                <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
                    {row.credits}
                </div>
            ),
        },
        {
            name: <label className="DarkBlue4_Color font_weight_500 font_14">Bonus Credits</label>,
            sortable: true,
            selector: row => row.bonus_credits,
            cell: row => (
                <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
                    {row.bonus_credits}
                </div>
            ),
        },
        {
            name: <label className="DarkBlue4_Color font_weight_500 font_14">Total Credits</label>,
            sortable: true,
            selector: row => row.total_credits,
            cell: row => (
                <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
                    {row.total_credits}
                </div>
            ),
        },
        {
            name: <label className="DarkBlue4_Color font_weight_500 font_14">Price</label>,
            sortable: true,
            selector: row => row.price,
            cell: row => (
                <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
                    {row.price}
                </div>
            ),
        },
        {
            name: <label className="DarkBlue4_Color font_weight_500 font_14">Currency</label>,
            sortable: true,
            selector: row => row.currency,
            cell: row => (
                <div className="DarkBlue4_Color font_weight_300 font_16 align-middle">
                    {row.currency}
                </div>
            ),
        },
        {
            name: <label className="DarkBlue4_Color font_weight_500 font_14">Status</label>,
            sortable: true,
            selector: row => row.is_active,
            cell: row => (
                <>
                    {row.is_active ? (
                        <span className="btn btn-success btn-sm activebtn btn-rounded waves-effect waves-light">Active</span>
                    ) : (
                        <span className="btn btn-danger btn-sm Inactivebtn btn-rounded waves-effect waves-light">Inactive</span>
                    )}
                </>
            ),
        },
        {
            name: <label className="DarkBlue4_Color font_weight_500 font_14">Action</label>,
            sortable: false,
            selector: row => row.id,
            cell: row => (
                <>
                    {/* {customeredit || customerdelete ? */}
                    <div>
                        <div
                            aria-label="more"
                            id="long-button"
                            aria-controls={open ? 'long-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={(event) => handleClick(event, row)}
                        >
                            <button
                                type="button"
                                className="btn btn-primary w-md btn-md dropdown-toggle"
                                aria-haspopup="true"
                                aria-expanded="false"
                                style={{ marginLeft: "10px" }}
                            >
                                Action
                                <i className="mdi mdi-chevron-down"></i>
                            </button>
                        </div>
                        <Menu
                            id="long-menu"
                            MenuListProps={{
                                'aria-labelledby': 'long-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            PaperProps={{
                                sx: {
                                    boxShadow: '0px 0px 0px 0px rgba(0,0,0,1), 0px 0px 0px 1px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12)',
                                    border: '1px solid #e0e0e0',
                                    outline: 'none',
                                    minWidth: '132px'
                                },
                                style: {
                                    border: '1px solid #fff',
                                }
                            }}
                        >
                            {/* {customeredit && */}
                            <MenuItem onClick={() => {
                                seteditid(selectedid);
                                settextbase("Update");
                                setCreatenewUser(true);
                                onloadeditedData(selectedidData);
                            }}>
                                Edit
                            </MenuItem>
                            {/* } */}
                            {/* {SelectedStatus === false && customerdelete ? */}
                            <MenuItem onClick={() => ChangeStatus(selectedid, true)}>
                                Activate
                            </MenuItem>

                            <MenuItem onClick={() => ChangeStatus(selectedid, false)}>
                                Deactivate
                            </MenuItem>
                            {/* } */}
                            {/* {customerdelete && */}
                            <MenuItem onClick={() => DeletePack(selectedid)}>
                                Delete
                            </MenuItem>
                            {/* } */}
                        </Menu>
                    </div>
                    {/* : ""} */}
                </>
            ),
        },
    ];

    const onloadeditedData = (data) => {
        setValueForm("name", data.name);
        setValueForm("description", data.description || '');
        setValueForm("credits", data.credits);
        setValueForm("bonus_credits", data.bonus_credits);
        setValueForm("price", data.price);
        setValueForm("currency", data.currency);
        setValueForm("sort_order", data.sort_order);
        setValueForm("is_active", data.is_active);
        setValueForm("is_featured", data.is_featured);
    };

    const onSubmit = async (data) => {
        const req = {
            name: data.name,
            slug: data.name.toLowerCase().replace(/\s+/g, '-'),
            description: data.description || '',
            credits: parseInt(data.credits),
            bonus_credits: parseInt(data.bonus_credits) || 0,
            price: data.price,
            currency: data.currency || 'USD',
            sort_order: parseInt(data.sort_order) || 1,
            is_active: !!data.is_active,
            is_featured: !!data.is_featured,
        };

        if (editid) {
            try {
                const response = await axios.patch(`/api/admin/add-credit-packs/${editid}/`, req);
                if (response.status === 200 || response.status === 201) {
                    triggerAlert('success', 'success', 'Credit Pack updated Successfully!!');
                    setCreatenewUser(false);
                    resetForm();
                    fetchListData(currentPage);
                }
            } catch (err) {
                if (err.response && err.response.data && err.response.data.message) {
                    triggerAlert('error', 'Oops...', err.response.data.message);
                } else {
                    triggerAlert('error', 'Oops...', 'Something went wrong..');
                }
            }
        } else {
            try {
                const response = await axios.post('/api/admin/add-credit-packs/', req);
                if (response.status === 200 || response.status === 201) {
                    triggerAlert('success', 'success', 'Credit Pack added Successfully!!');
                    setCreatenewUser(false);
                    resetForm();
                    fetchListData(1);
                }
            } catch (err) {
                if (err.response && err.response.data && err.response.data.message) {
                    triggerAlert('error', 'Oops...', err.response.data.message);
                } else {
                    triggerAlert('error', 'Oops...', 'Something went wrong..');
                }
            }
        }
    };

    const ChangeStatus = async (id, isActive) => {
        handleClose();
        let req = { is_active: isActive };
        try {
            const response = await axios.patch(`/api/admin/add-credit-packs/${id}/`, req);
            if (response.status === 200 || response.status === 201) {
                fetchListData(currentPage);
                triggerAlert('success', 'success', 'Status updated Successfully!!');
            }
        } catch (err) {
            console.log(err?.data?.response?.message);
        }
    };

    const DeletePack = (id) => {
        handleClose();
        ConfirmationAlert('Are you sure you want to delete this credit pack?', 'Continue', async () => {
            try {
                const response = await axios.delete(`/api/admin/add-credit-packs/${id}/`);
                if (response.status === 200 || response.status === 204) {
                    triggerAlert('success', 'success', 'Credit Pack Deleted Successfully!!');
                    fetchListData(1);
                } else {
                    triggerAlert('error', 'Oops...', 'Something went wrong..');
                }
            } catch (error) {
                triggerAlert('error', 'Oops...', 'Failed to delete credit pack..');
            }
        });
    };

    const handlePageChange = (page) => {
        fetchListData(page, perPage);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchListData(page, newPerPage);
        setPerPage(newPerPage);
    };

    const customStyles = {
        table: {
            style: {
                backgroundColor: "#ffffff",
                borderRadius: "8px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#064c77",
                borderBottom: "1px solid #dee2e6",
                minHeight: "52px",
            },
        },
        headCells: {
            style: {
                color: "#ffffff",
                fontSize: "13px",
                fontWeight: "700",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "56px",
                backgroundColor: "#ffffff",
                "&:hover": {
                    backgroundColor: "#f8f9fa",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                },
            },
        },
        cells: {
            style: {
                fontSize: "14px",
                color: "#495057",
                borderBottom: "1px solid #f1f3f5",
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #dee2e6",
                padding: "8px",
            },
        },
        noData: {
            style: {
                backgroundColor: "#ffffff",
                color: "#6c757d",
                padding: "24px",
            },
        },
    };

    return (
        <>
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="main-content">
                    <div className="page-content" style={{ backgroundColor: "#ededed" }}>
                        <div className="container-fluid">

                            <PageHeader mainHeading={mainHeading} heading={heading} />

                            <div className="row">
                                <div className="col-12">
                                    <div className="">
                                        <div className="">
                                            {/* {customeradd && */}
                                            <div className="btn-group float-end col-md-1 ml-10">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary w-md btn-md"
                                                    onClick={() => {
                                                        setCreatenewUser(true);
                                                        settextbase("Create");
                                                        seteditid('');
                                                        resetForm();
                                                    }}
                                                    style={{ marginLeft: "10px" }}
                                                >
                                                    Create Pack
                                                </button>
                                            </div>
                                            {/* } */}
                                        </div>

                                        <div className="">
                                            <div id="datatable_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                                <div className="row my-3">
                                                    <div className="col-sm-12 col-md-12 mb-2">
                                                        <div className="btn-group float-end ">
                                                            <input type="search" placeholder="Search..." value={searchQuery} className="form-control form-control-sm" onChange={handleKeySearch} style={{ borderRadius: '7px' }} />
                                                        </div>
                                                    </div>
                                                </div>

                                                {!isLoading ?
                                                    <DataTable
                                                        columns={columns}
                                                        data={listData}
                                                        pagination
                                                        paginationServer
                                                        fixedHeaderScrollHeight='600px'
                                                        fixedHeader
                                                        persistTableHead
                                                        paginationTotalRows={totalRows}
                                                        paginationDefaultPage={currentPage}
                                                        customStyles={customStyles}
                                                        onChangeRowsPerPage={handlePerRowsChange}
                                                        onChangePage={handlePageChange}
                                                    /> :
                                                    <div className='loader-overlay text-white'>
                                                        <Loader />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>

            <Modal size='lg' scrollable show={CreatenewUser} onHide={() => { setCreatenewUser(false); resetForm(); }} className='modal fade' backdrop="static" keyboard={false}>
                <Modal.Header className='modal-header_box bg-my-primary p-3 d-flex justify-content-between' closeButton>
                    <h1 className="modal-title fs-5">{textbase} Credit Pack</h1>
                </Modal.Header>
                <form onSubmit={handleSubmitForm(onSubmit)}>
                    <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto', paddingRight: '12px' }}>
                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="form-label">Pack Name <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" {...registerForm('name', { required: 'Pack Name is required' })} />
                                    {errorsForm.name && <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.name.message}</div>}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="form-label">Currency <span className="text-danger">*</span></label>
                                    <select className="form-select" {...registerForm('currency', { required: 'Currency is required' })}>
                                        <option value="">Select</option>
                                        <option value="USD">USD</option>
                                        <option value="INR">INR</option>
                                        <option value="EUR">EUR</option>
                                    </select>
                                    {errorsForm.currency && <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.currency.message}</div>}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="form-label">Credits <span className="text-danger">*</span></label>
                                    <input type="number" min="0" className="form-control" {...registerForm('credits', { required: 'Credits is required' })} />
                                    {errorsForm.credits && <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.credits.message}</div>}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="form-label">Bonus Credits</label>
                                    <input type="number" min="0" className="form-control" {...registerForm('bonus_credits')} />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="form-label">Price <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" {...registerForm('price', { required: 'Price is required', pattern: { value: /^\d+(\.\d{1,2})?$/, message: 'Valid price required' } })} />
                                    {errorsForm.price && <div style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>{errorsForm.price.message}</div>}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="form-label">Sort Order</label>
                                    <input type="number" min="0" className="form-control" {...registerForm('sort_order')} />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea className="form-control" {...registerForm('description')} rows="3" />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-check mb-2">
                                    <input type="checkbox" className="form-check-input" id="is_active" {...registerForm('is_active')} />
                                    <label className="form-check-label" htmlFor="is_active">Is Active</label>
                                </div>
                                <div className="form-check mb-2">
                                    <input type="checkbox" className="form-check-input" id="is_featured" {...registerForm('is_featured')} />
                                    <label className="form-check-label" htmlFor="is_featured">Is Featured</label>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <Modal.Footer>
                        <div className="py-2 mb-3">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <button className='btn btn-warning w-md btn-md me-2' type="button" onClick={() => { setCreatenewUser(false); resetForm(); }}>Cancel</button>
                                    <button className='btn btn-primary w-md btn-md' type="submit">Save</button>
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}
